// @flow

import type {
  RequestResetPasswordOperation,
} from 'hfty-auth/types'

// Libs
import React, { Component } from 'react'
import _delay from 'lodash/delay'

// Components
import { Dialog, DialogBody, DialogFooter, DialogHeader, DialogTitle } from 'react-mdc-web/lib/Dialog'
import Button from 'react-mdc-web/lib/Button'

// Styles
import { lightGreen } from 'hfty-styles/src/colors'

// Translations
import messages from './../messages'
import { FormattedMessage } from 'react-intl'

type Props = {
  open: boolean,
  onClose: Function,
  actions: {
    onSubmit: Function,
  },
  operation: RequestResetPasswordOperation,
  viewport: {
    width: number,
  }
}

export default class EmailInUseDialog extends Component {
  props: Props

  componentWillReceiveProps (nextProps: Props) {
    if (!this.props.operation.success && nextProps.operation.success) {
      _delay((props: Props): void => props.onClose(), 4000, this.props)
    }
  }

  render (): React.Element<any> {
    const mobile = this.props.viewport.width < 768
    const isSubmitting = this.props.operation.submitting
    const isSuccess = this.props.operation.success
    const messageId = isSuccess ? 'passwordResetEmailSent' : 'emailAlreadyExistsMessage'
    const isSubmitText = isSubmitting ? 'sending' : 'email_my_info'
    return (
      <Dialog
        open={this.props.open}
        onClose={this.props.onClose}
      >
        <DialogHeader>
          <DialogTitle>
            <span style={{ color: lightGreen() }}>
              <FormattedMessage
                {...messages['rgstrtn.email_already_in_use']}
              />
            </span>
          </DialogTitle>
        </DialogHeader>
        <DialogBody>
          <FormattedMessage {...messages[messageId]} />
        </DialogBody>
        {!this.props.operation.success && (
          <DialogFooter>
            <Button
              disabled={this.props.operation.success}
              raised
              primary
              onClick={this.props.actions.onSubmit}
            >
              <FormattedMessage {...messages[isSubmitText]} />
            </Button>
            <Button
              disabled={this.props.operation.success}
              onClick={this.props.onClose}
              style={mobile ? { marginTop: 10 } : {}}
            >
              <FormattedMessage {...messages['rgstrtn.create_new_account']} />
            </Button>
          </DialogFooter>
        )}
      </Dialog>
    )
  }
}
